import { noop } from 'lodash';
import { browserHistory } from 'common/utils/browserHistory';
import STEP_DEFAULTS from './utils/defaults';
import {
  SEARCH_PATH,
  CONFIRM_PATH,
  ADD_INFORMATION_PATH,
} from '../constants';

const contactsStepperConfig = {
  steps: [
    {
      ...STEP_DEFAULTS.first,
      title: 'Search Records',
      onStepClick: () => {
        browserHistory.push(`/contacts/${SEARCH_PATH}`);
      },
      routes: [
        {
          route: `/contacts/${SEARCH_PATH}`,
        },
        {
          route: `/contacts/${CONFIRM_PATH}`,
        },
      ],
    },
    {
      ...STEP_DEFAULTS.second,
      title: 'Contact Information',
      onStepClick: noop,
      onStepComplete: ({
        removeSelectedContact = noop,
      }) => {
        removeSelectedContact();
      },
      routes: [
        {
          route: `/contacts/${ADD_INFORMATION_PATH}`,
        },
      ],
    },
  ],
};

export default contactsStepperConfig;
